import { useState } from "react";
import { Link } from "react-router-dom";
import { Activity, Menu, X } from "lucide-react";

const LINKS = [["How it works", "/#how"], ["Industries", "/#industries"], ["Pricing", "/#pricing"], ["Sales material", "/sales"]];

export const Logo = ({ small }) => (
  <Link to="/" data-testid="site-logo" className="flex items-center gap-2 group">
    <span className="w-8 h-8 bg-amber-500 flex items-center justify-center"><Activity className="w-5 h-5 text-[#080D1A]" strokeWidth={2.5} /></span>
    <span className={`font-heading font-bold tracking-wide text-slate-100 ${small ? "text-base" : "text-lg"}`}>PULSE <span className="text-slate-400 font-semibold">COMMISSIONING</span></span>
  </Link>
);

export function SiteNav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#080D1A]/85 border-b border-[#1E2D4A]" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map(([label, href]) => (
            <a key={href} href={href} data-testid={`nav-${label.toLowerCase().replace(/ /g, "-")}`} className="text-sm text-slate-300 hover:text-amber-400 transition-colors">{label}</a>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <Link to="/login" data-testid="nav-sign-in" className="text-sm text-slate-300 hover:text-white px-3 py-2">Sign in</Link>
          <a href="/#demo" data-testid="nav-request-demo" className="btn-accent text-sm px-4 py-2">Request a demo</a>
        </div>
        <button className="lg:hidden p-2 text-slate-200" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-[#1E2D4A] bg-[#080D1A] px-5 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {LINKS.map(([label, href]) => <a key={href} href={href} onClick={() => setOpen(false)} className="text-slate-200 py-1">{label}</a>)}
          <Link to="/login" className="text-slate-200 py-1">Sign in</Link>
          <a href="/#demo" onClick={() => setOpen(false)} className="btn-accent text-center py-3">Request a demo</a>
        </div>
      )}
    </header>
  );
}
